module.exports = __webpack_public_path__ + "static/media/icon_72.da68f013.svg";